"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HorizontalBars = HorizontalBars;
var _react = _interopRequireWildcard(require("react"));
var _layout = require("../../layout");
var _styled = require("../../styled");
var _styled2 = require("./styled");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
//
// Main component
// -------------------------------------------------------------------------------------------------

function HorizontalBars({
  bordered = false,
  gap = 1,
  children
}) {
  const baseRef = (0, _react.useRef)(null);
  if (!children) return null;

  // Round up all of the values from the bars.
  const values = _react.default.Children.map(children, ({
    props: {
      value
    }
  }) => {
    return typeof value === 'string' ? Number.parseInt(value, 10) : value;
  });

  // We'll need to grab the highest value to calculate the percent that represents the width of the bar.
  const maxValue = Math.max(...values);

  // Collect the colors for each bar.
  const colors = _react.default.Children.map(children, child => child.props.color);
  return /*#__PURE__*/_react.default.createElement(_styled2.StyledBase, {
    ref: baseRef
  }, /*#__PURE__*/_react.default.createElement(_layout.Stack, {
    gap: gap,
    justify: "space-around"
  }, _react.default.Children.map(children, (child, i) => {
    const percent = values[i] / maxValue * 100;
    const barColorStyle = (0, _styled.css)({
      backgroundColor: colors[i],
      width: `${percent}%`
    });
    return /*#__PURE__*/_react.default.createElement(_styled2.StyledBarContainer, {
      key: i
    }, /*#__PURE__*/_react.default.createElement(_styled2.StyledChildContainer, null, child), /*#__PURE__*/_react.default.createElement(_styled2.StyledBar, {
      bordered: bordered,
      className: barColorStyle()
    }));
  })));
}

//
// Sub-components
// -------------------------------------------------------------------------------------------------

HorizontalBars.Bar = Bar;
function Bar({
  children,
  testId,
  value
}) {
  return /*#__PURE__*/_react.default.createElement(_styled2.StyledCaption, {
    "data-testid": testId,
    value: value
  }, children);
}